import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { AppleCreateNotificationsProfileComponent } from '../apple-edit-panel/apple-create-notifications-profile/apple-create-notifications-profile.component';
import { AppleCreateRestrictionsProfileComponent } from '../apple-edit-panel/apple-create-restrictions-profile/apple-create-restrictions-profile.component';
import { AppleCreateWifiProfileComponent } from '../apple-edit-panel/apple-create-wifi-profile/apple-create-wifi-profile.component';

@Component({
  selector: 'ml-install-profile-modal',
  templateUrl: './install-profile-modal.component.html',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    AppleCreateWifiProfileComponent,
    AppleCreateNotificationsProfileComponent,
    AppleCreateRestrictionsProfileComponent,
    AsyncPipe,
  ],
})
export class InstallProfileModalComponent {
  public readonly activeModal = inject(NgbActiveModal);

  public udid$: Observable<string>;
  public selectedProfile: string;
}
